module.exports = __webpack_public_path__ + "img/Box-8.e65dbb22.png";